module.exports = __webpack_public_path__ + "static/media/load3.a04f12a0.PNG";